// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/PlatformWebhooks_SubscriptionsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/** GET /platform-webhooks/subscriptions */
import type { PlatformWebhooks_SubscriptionRow } from './PlatformWebhooks_SubscriptionRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface PlatformWebhooks_SubscriptionsResponseDados {
rows: PlatformWebhooks_SubscriptionRow[]
}

export type PlatformWebhooks_SubscriptionsResponse = ApiResponse<PlatformWebhooks_SubscriptionsResponseDados>;

registerResponseContract('PlatformWebhooks_SubscriptionsResponse', {
  rows: {
    type: 'array',
    required: true,
    items: {
      id:         { type: 'number',  required: true },
      plugin:     { type: 'string',  required: false },
      url:        { type: 'string',  required: false },
      events:     { type: 'array',   required: false },
      enabled:    { type: 'boolean', required: false },
      contract:   { type: 'string',  required: false },
      delivery:   { type: 'string',  required: false },
      managed:    { type: 'boolean', required: false },
      created_at: { type: 'string',  required: false },
      updated_at: { type: 'string',  required: false },
    },
  },
})
